/*
 * action types
 */

export const SELECT = 'SELECT';
export const RESET = 'RESET';